document.addEventListener('DOMContentLoaded', () => {

    initVariantsToAdd();
    
    // Add to cart function 
    document.addEventListener('click', (e) => {            
        const target = e.target;
        if(target.classList.contains('js-add-to-cart')) {
            e.preventDefault();
            e.stopPropagation();       
            const variantId = target.getAttribute('data-variant-id');
            const qtyContainer = target.previousElementSibling;
            const qtyInput = qtyContainer.querySelector('.js-qty__num');
            const errorContainer = qtyContainer.parentElement.previousElementSibling;
            if(variantId) {
                const value = parseInt(qtyInput.value);
                target.textContent = 'Agregando...'
                addToCart(variantId, value, target, errorContainer);  
                // createAlert("El producto se agrego exitosamente!!")              
            } else {
                console.log("Primero seleccione un color");
                errorContainer.innerHTML = "Primero seleccione un color y un talle";
                setTimeout(() => {
                    errorContainer.innerHTML = '';
                }, 3500)
            }
        }            
    });
});

document.addEventListener('recommendation:loaded', () => {
    initVariantsToAdd();
});

const initVariantsToAdd = () => {
    const gridProductCustom = [...document.getElementsByClassName('grid-product-custom')];

    if(gridProductCustom.length > 0) {
        gridProductCustom.forEach(grid => {
            const swatches = [...grid.getElementsByClassName('js-color-swatch')];
            const qtyWrappper = grid.querySelector('.js-qty__wrapper');            
            const btnAddToCart = grid.querySelector('.js-add-to-cart');
            const wrapSizes = grid.querySelector('.wrap-sizes');
            const gridProductSku = grid.querySelector('.grid-product__sku');
            //const gridProductPrice = grid.querySelector('.grid-product__price');
            
            // Click listener to all color swatches
            if(swatches.length > 0) {                
                swatches.forEach(swatch => {
                    swatch.addEventListener('click', (e) => {
                        //e.preventDefault();
                        //e.stopPropagation();

                        const target = e.target;

                        if(!target.classList.contains('active')) {
                            const produtcHandle = target.getAttribute('data-product-handle');
                            const indexColor = target.getAttribute('data-index-color');
                            const ValueColor = target.getAttribute('data-value');

                            [...target.parentElement.querySelectorAll('button')].forEach(e => {
                                e.classList.remove('active');
                            })
                            target.classList.add('active');

                            fetch(`/products/${produtcHandle}.js`)
                                .then(data => data.json())
                                .then(data => {
                                    const variants = data.variants;
                                    const variantsSelected = variants.filter(variant => {
                                    return variant[`option${indexColor}`] === ValueColor
                                    });
                                    let optSearch;
                                    switch(indexColor) {
                                        case '1':
                                            optSearch = 2;                                     
                                            break;
                                        case '2':
                                            optSearch = 1;
                                            break;
                                        default:
                                            break;
                                    }
                                    wrapSizes.innerHTML = '';
                                    variantsSelected.forEach( (variant, index) => {
                                        const value = variant[`option${optSearch}`];
                                        const id = variant.id;
                                        const available = variant.available;
                                        const sku = variant.sku;
                                        //const price = theme.Currency.formatMoney(variant.price)
                                        let newBtn = document.createElement('button');
                                        newBtn.innerHTML = value;
                                        newBtn.setAttribute('data-value', value);
                                        newBtn.setAttribute('type', 'button');
                                        newBtn.setAttribute('class', 'size-variant');
                                        newBtn.setAttribute('data-variant', id)
                                        newBtn.addEventListener('click', (e) => {
                                            const target = e.target;
                                            if(!target.classList.contains('active')) {
                                                [...target.parentElement.querySelectorAll('button')].forEach(e => {
                                                    e.classList.remove('active');
                                                });
                                                target.classList.add('active');
                                                
                                                //gridProductPrice.textContent = price;
                                                gridProductSku.textContent = sku;

                                                if(available) {
                                                    btnAddToCart.setAttribute('data-variant-id', id);
                                                    btnAddToCart.removeAttribute('disabled');
                                                    btnAddToCart.textContent = theme.strings.defaultAddText;
                                                } else {
                                                    btnAddToCart.setAttribute('disabled', 'disabled');
                                                    btnAddToCart.textContent = theme.strings.soldOut;
                                                }
                                            }               
                                        })
                                        wrapSizes.appendChild(newBtn);
                                        if (index === 0) {
                                            newBtn.click();
                                        }
                                    });
                                })
                        }                        
                    });
                });                
                swatches[0].click();
            }

            // To generate all quantity selectors functionality
            if(qtyWrappper) {
                new theme.QtySelector($(qtyWrappper), {
                    namespace: '.product'
                });
            }
        });        
    }
}

const addToCart = async (id, qty, btn, errorContainer) => {
    const defaulText = theme.strings.defaultAddText;
    //const cartAmmount = document.getElementById('CartAmmount');
    const buble = document.querySelector('.cart-link__bubble');
    const subheader = document.getElementById('Subheader');
    const subheaderBuble = subheader.querySelector('.cart-link__bubble');
    theme.cart.addItemFromForm({
        'id': id,
        'quantity': qty
    })
    .then(response => {
        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            
            btn.textContent = defaulText;
            
            if (cart.items.length > 0) {
                buble.classList.add('cart-link__bubble--visible');
                subheaderBuble.classList.add('cart-link__bubble--visible');
            } else {
                buble.classList.remove('cart-link__bubble--visible');
                subheaderBuble.classList.add('cart-link__bubble--visible');
            }
            
            createAlert("El producto se agrego exitosamente!!")              

        })
    })
    .catch((error) => {      
        console.error('Error:', error.responseJSON.description);
        errorContainer.innerHTML = error.responseJSON.description;
        btn.textContent = defaulText;
        setTimeout(() => {
            errorContainer.innerHTML = '';
        }, 3500);
    });
}

function createAlert(text) {
    let containerAlert = document.createElement('div')
    let textAlert = document.createElement('p')
    const mainContent = document.querySelector('#MainContent')
    containerAlert.setAttribute('class', 'container__alert')
    textAlert.setAttribute('class', 'text__alert')
    textAlert.textContent = text
    containerAlert.appendChild(textAlert)
    mainContent.appendChild(containerAlert)
    setTimeout(() => {
        containerAlert.remove()
    }, 3000);
}